// This script runs before the page renders to prevent theme flash
(function () {
  const getInitialTheme = () => {
    // Check if theme is stored in localStorage
    const storedTheme = localStorage.getItem("theme");
    if (storedTheme) {
      return storedTheme;
    }

    // Check system preference
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      return "dark";
    }

    return "light";
  };

  const theme = getInitialTheme();
  document.documentElement.classList.add(theme);
})();
